import { Center } from '@/types/models'
import { fetchFeaturedCenters } from '@/repository/center/fetchFeaturedCenter'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import locationListIncludesUnitedKingdom from '@/domain/location/useCases/locationListIncludesUnitedKingdom'
import { CONTINENT_LOCATIONS } from '@/domain/location/constants'
import { getLocations } from '@/domain/center'
import { getTitle } from '@/domain/location'

const HITS_PER_PAGE = 15

export const getFeaturedCentersRelatedToCenterLocation = async ({
  center,
  hitsPerPage = HITS_PER_PAGE,
  primaryFocus,
  termData,
  aroundRadius,
  aroundPrecision,
  aroundLatLng
}: {
  center: Center
  hitsPerPage: number
  primaryFocus?: PrimaryFocus
  termData?: { type: string; title: string }
  aroundRadius?: number | string
  aroundPrecision?: number | string
  aroundLatLng?: string
}): Promise<Center[]> => {
  const centerLocations = getLocations(center)

  const includesUnitedKingdom = locationListIncludesUnitedKingdom(
    centerLocations.map(getTitle)
  )

  let locationToSearch = getTitle(
    centerLocations.find(({ type }) => type === 'Country' || type === 'Region')
  )

  if (includesUnitedKingdom) {
    locationToSearch = CONTINENT_LOCATIONS.EUROPE
  }

  return await fetchFeaturedCenters({
    location: locationToSearch,
    hitsPerPage,
    primaryFocus,
    termData,
    aroundRadius,
    aroundPrecision,
    aroundLatLng
  })
}
